import { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import PasswordHide from "../Vectors/PasswordHide";
import PasswordVisible from "../Vectors/PasswordVisible";

const DelendPasswordField = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  return (
    <TextField
      error={props.error !== undefined ? props.error  : false }
      helperText={props.helperText && props.error ? props.helperText : " "}
      label={props.label}
      name={props.name}
      value={props.value}
      fullWidth={props.fullWidth}
      onChange={props.onChange}
      color="secondary"
      style={{fontSize: 12,
        '& .MuiFormLabelRoot': {
           fontSize: 12,
       }}}
      variant="standard"
      InputLabelProps={{
        style: { color: '#8087A6', fontSize: 14, lineHeight : '24px'  }
      }}
      type={showPassword ? "text" : "password"}
      InputProps={{
        style : {height: 30,fontSize : 12},
        endAdornment: (
          <InputAdornment sx={{marginRight: '-5px'}} position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              sx={{  "&:hover": {backgroundColor: "transparent"}}}
            >
              {showPassword ? <PasswordVisible text={props.value} /> : <PasswordHide  text={props.value} />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default DelendPasswordField;
